import builder from '../builder';
import ModernTVFlatScreen from '../../streamline-icons/bold/modern-tv-flat-screen.svg';

export default builder('IconModernTVFlatScreenBold', ModernTVFlatScreen);
